module.exports = __webpack_public_path__ + "static/media/scan1.10b84a96.svg";